import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TeacherPersonalProfileFormComponentEvent, TeacherPersonalProfileFormComponent
 } from 'src/app/components/teacher/teacher-personal-profile-form/teacher-personal-profile-form.component';
import { ComponentEvent } from 'src/app/model/rest/base';
import { TeacherProfileFormComponent, TeacherProfileFormComponentEvent
} from 'src/app/components/teacher/teacher-profile-form/teacher-profile-form.component';

@Component({
  selector: 'app-teacher-profile-page',
  templateUrl: './teacher-profile-page.component.html',
  styleUrls: ['./teacher-profile-page.component.css']
})
export class TeacherProfilePageComponent implements OnInit {
  teacherId: string;
  personalProfileReady = false;
  personalProfileUnderEdit = false;
  teacherProfileReady = false;
  teacherProfileUnderEdit = false;
  @ViewChild('teacherPersonalProfileFormComponent', {static: true})
  teacherPersonalProfileForm: TeacherPersonalProfileFormComponent;
  @ViewChild('teacherProfileFormComponent', {static: true})
  teacherProfileForm: TeacherProfileFormComponent;

  constructor(private route: ActivatedRoute) { }

  onPersonalProfileEvent(event: TeacherPersonalProfileFormComponentEvent) {
    if (event.eventType === ComponentEvent.ET_INITIALIZED) {
      this.personalProfileReady = true;
    } else if (event.eventType === TeacherPersonalProfileFormComponentEvent.ET_FORM_EDITABLE) {
      this.personalProfileUnderEdit = true;
    } else if (event.eventType === TeacherPersonalProfileFormComponentEvent.ET_FORM_READ_ONLY) {
      this.personalProfileUnderEdit = false;
    }
  }

  onTeacherProfileEvent(event: TeacherProfileFormComponentEvent) {
    if (event.eventType === ComponentEvent.ET_INITIALIZED) {
      this.teacherProfileReady = true;
    } else if (event.eventType === TeacherProfileFormComponentEvent.ET_FORM_EDITABLE) {
      this.teacherProfileUnderEdit = true;
    } else if (event.eventType === TeacherProfileFormComponentEvent.ET_FORM_READ_ONLY) {
      this.teacherProfileUnderEdit = false;
    }
  }

  editPersonalProfile() {
    this.teacherPersonalProfileForm.editable = true;
  }

  editTeacherProfile() {
    this.teacherProfileForm.editable = true;
  }

  ngOnInit() {
    this.route.parent.paramMap.subscribe( params => this.teacherId = params.get('teacherId'));
  }

}
